import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "set-filter" }, "Нажмите кнопку показать!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_component = _resolveComponent("filter-component")!
  const _component_ws_logs_view = _resolveComponent("ws-logs-view")!
  const _component_bs_col = _resolveComponent("bs-col")!
  const _component_bs_row = _resolveComponent("bs-row")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, {
    name: "Просмотр ws логов",
    selectSource: false
  }, {
    toolbar: _withCtx(() => [
      _createVNode(_component_filter_component, {
        filter: _ctx.filterModel,
        "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterModel) = $event)),
        onFilterData: _ctx.onclickFilterChange,
        onClear: _ctx.clear,
        selectInterval: false,
        methods: false,
        slectSource: true,
        selectViewFilter: false,
        logsType: false,
        url: true,
        requestId: true,
        connectionId: false,
        sessionToken: true,
        ip: true,
        userId: true,
        projectLogGroupId: false,
        loggerName: false,
        shortMessage: false
      }, null, 8, ["filter", "onFilterData", "onClear"])
    ]),
    default: _withCtx((slotProps) => [
      _createVNode(_component_ws_logs_view, {
        filter: _ctx.filterModel,
        onUpdateQuery: _ctx.updatePaginationQuery,
        ref: "page"
      }, null, 8, ["filter", "onUpdateQuery"]),
      (!_ctx.filterModel)
        ? (_openBlock(), _createBlock(_component_bs_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_bs_col, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}